import React, { useState } from 'react'
import { getBEMCls } from '@/utils/classname'
import logo from '@/assets/images/logo.svg'
import User from '../user/user'
import './header.scss'
import { shopStore } from '@/store/shop'
import { getQiniuImgUrl } from '@/config/qiniu'
import Iconfont from '@/components/iconfont/iconfont'
import { Row } from '@/components/layout/layout'
import { observer } from 'mobx-react'
import $msg from '@/utils/message'

// interface HeaderProps {
//     shopName: string
//     logo: string
// }

const Header: React.FC = observer(() => {
    const getCls = (el?: string, moder?: string) => getBEMCls('header', el, moder)
    const [showExpiry, setShowExpiry] = useState(true)
    const shop = shopStore.shopInfo
    const showWarning = showExpiry && shop?.remain_days != null && shop.remain_days <= 30

    return (
        <header className={getCls()}>
            <div className={getCls('left')}>
                <img alt="" src={logo} className={getCls('logo')} />
                <div className={getCls('title')}>· 零售后台</div>
                <div className={getCls('line')} />
                <img
                    alt=""
                    src={getQiniuImgUrl(shopStore.shopInfo!.logo_image_url)}
                    className={getCls('shop', 'img')}
                />
                <div
                    className={getCls('title')}
                    data-cursor-pointer
                    onClick={() => {
                        window.location.href = 'https://center.senguo.cc/#/main/shopList'
                    }}
                >
                    {shopStore.shopInfo!.shop_name}
                </div>
                <Iconfont
                    size={20}
                    name="icon6xiala2-202"
                    style={{
                        marginLeft: '10px',
                    }}
                />
            </div>
            <Row data-align-items-center>
                {showWarning && shop && (
                    <div className={getCls('expiry')} role="status">
                        {shop.remain_days > 0 ? `${shop.remain_days}天后到期` : '店铺已到期'}， 请及时
                        {shop.use_status === 0 ? '开通正式版' : '续费/升级'}以免影响使用。
                        <span
                            className={getCls('expiry-action')}
                            onClick={() => $msg('info', '请前往零售通客户端操作')}
                        >
                            了解续费
                        </span>
                        <span className={getCls('expiry-close')} onClick={() => setShowExpiry(false)}>
                            ×
                        </span>
                    </div>
                )}
                <User />
            </Row>
        </header>
    )
})

export default Header
